import React from 'react';
import { componentService } from 'js/services/component.service';

export const Timeout = React.lazy(() => import(/* webpackChunkName: "timeout" */ './Timeout'));

componentService.registerPageComponents({ timeout: Timeout });
